import "./MowerList.scss"
import { Accordion, AccordionItem, Box, Skeleton } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import { ProposalProduct } from "../../models/ProposalProduct";
import Project from "../../models/Project";
import MowerListItem from "./MowerListItem";
import { useGetAllProductsQuery } from "../../projectApi";
import { Product } from "../../models/Product";
import { useEffect, useState } from "react";
import { ProductType } from "../../models/Enums";

export type MowerListProps = {
  proposalMowers: ProposalProduct[];
  project: Project;
  expandedAccordions: string[];
  onItemClick?: (mower: Product, proposalMower?: ProposalProduct) => void;
};

const MowerList = ({
  proposalMowers,
  project,
  expandedAccordions,
  onItemClick,
} : MowerListProps) => {
  const intl = useIntl();
  const { data: products, isLoading } = useGetAllProductsQuery(project?.id ?? "");
  const [mowers, setMowers] = useState<Product[]>([]);

  useEffect(() => {
    if(products && !isLoading) {
      setMowers(products.filter(x => x.type === ProductType.Mower))
    }
  }, [products]);

  const handleOnClick = (mower: Product, proposalProduct?: ProposalProduct) => {
    onItemClick?.call(this, mower, proposalProduct);
  }

  return (
        <Accordion expandedId={expandedAccordions}>
          {!!project.proposal.mowers && (
            <Box mb={5}>
              <AccordionItem
                id="assigned"
                title={intl.formatMessage({
                  id: "projects.equipment.MowerList.accordionAssigned",
                  defaultMessage: "Assigned ({mowerCount})",
                }, {mowerCount: project.proposal.mowers.reduce((sum, obj) => sum + obj.quantity, 0)})}
              >
                {proposalMowers &&
                  [...proposalMowers].sort((a, b) => a.product.name.localeCompare(b.product.name))
                    .map((proposalProduct, index) => (
                    <MowerListItem
                      key={index}
                      project={project}
                      mower={proposalProduct.product}
                      proposalProduct={proposalProduct}
                      onClick={() => {
                        handleOnClick(proposalProduct.product, proposalProduct);
                      }}
                    />
                  ))}
              </AccordionItem>
            </Box>
          )}
          <AccordionItem
            title={intl.formatMessage({
              id: "projects.equipment.MowerList.accordionCatalogue",
              defaultMessage: "Catalogue",
            })}
            id="catalogue"
          >
            {isLoading && (
              <Box flexDirection="column" gap={3}>
                <Skeleton height="40px" mx={6} br={4} />
                <Skeleton height="40px" mx={6} br={4} />
                <Skeleton height="40px" mx={6} br={4} />
              </Box>
            )}
            {!isLoading && mowers && mowers.map((mower, index) => (
                <MowerListItem
                  key={index}
                  project={project}
                  mower={mower}
                  onClick={(mower) => {
                    handleOnClick(mower);
                  }}
                />
              ))}
          </AccordionItem>
        </Accordion>
  );
};

export default MowerList;
